<script setup lang="ts">
import TextInput from './commons/TextInput.vue';
import SelectInput from './commons/SelectInput.vue';
import useShippingAddress from '../composables/useShippingAddress';
import useCheckout from '../composables/useCheckout';
import {i18n} from "@/libs/wordpress.facade";
import { useTemplateRef } from 'vue';

const {step, wooCart} = useCheckout();
const shippingAddress = useShippingAddress();
const {form} = shippingAddress;
const {controllers} = form;

const formElRef = useTemplateRef('form-container');

function scrollTo(element: HTMLElement|null){
	if(!element) return;
	window.scrollTo({behavior: 'smooth', top: element.getBoundingClientRect().top + window.pageYOffset - 50});
}

function confirm(){
	if(!form.validate()) return;
	form.disabled.value = true;
	if(!form.validate()){
		scrollTo(formElRef.value);
		return;
	}
	shippingAddress.save().then((error) => {
		if(error){
			return;
		}
		step.value++;
	}).catch(e => {})
	.then(() => {
		form.disabled.value = false;
	});
}

function back(){
	if(!wooCart.showShippingMethodStep.value) step.value -= 2;
	else step.value--;
}
</script>

<template lang="pug">
.itlp-checkout-shipping-address-form-content(ref='form-container')
	.itlp-checkout-shipping-address-form-title {{i18n.__('Destinatario', 'italpreziosi')}}
	.itlp-checkout-shipping-address-form-row
		text-input(v-if='controllers["firstname"]' :controller="controllers['firstname']")
		text-input(v-if='controllers["lastname"]' :controller="controllers['lastname']")
	.itlp-checkout-shipping-address-form-row
		text-input.itlp-checkout-shipping-address-form-row-item-full(v-if='controllers["address"]' :controller="controllers['address']")
	.itlp-checkout-shipping-address-form-row
		text-input(v-if='controllers["city"]' :controller="controllers['city']")
		text-input(v-if='controllers["province"] && controllers["province"].inputType.value == "text"' :controller="controllers['province']")
		select-input(v-if='controllers["province"] && controllers["province"].inputType.value == "select"' :controller="controllers['province']")
		div(v-if='controllers["province"] && controllers["province"].inputType.value == "hidden"')
	.itlp-checkout-shipping-address-form-row
		text-input(v-if='controllers["postcode"]' :controller="controllers['postcode']")
		select-input(v-if='controllers["country"]' :controller="controllers['country']")
	.itlp-checkout-shipping-address-form-row
		text-input(v-if='controllers["phone"]' :controller="controllers['phone']")
		div
.itlp-checkout-shipping-address-form-footer
	button(@click="back()") {{i18n.__('Indietro', 'italpreziosi')}}
	button(@click="confirm()" :disabled='Boolean(wooCart.requesting.value)') {{i18n.__('Conferma', 'italpreziosi')}}
</template>

<style>
.itlp-checkout-shipping-address-form-content{
	flex: 1;
}
.itlp-checkout-shipping-address-form-title{
	margin-top: 12px;
}
.itlp-checkout-shipping-address-form-row{
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	gap: 30px;
	margin-top: 8px;
}
.itlp-checkout-shipping-address-form-row > div{
	flex: 0.5;
}

.itlp-checkout-shipping-address-form-row > .itlp-checkout-shipping-address-form-row-item-full{
	flex: 1;
}
</style>